export const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];

export const colors = [
    "rgba(255, 99, 132, 0.7)", // Red
    "rgba(54, 162, 235, 0.7)", // Blue
    "rgba(255, 206, 86, 0.7)", // Yellow
    "rgba(75, 192, 192, 0.7)", // Green
    "rgba(153, 102, 255, 0.7)", // Purple
    "rgba(255, 159, 64, 0.7)", // Orange
    "rgba(199, 199, 199, 0.7)", // Grey
    "rgba(83, 102, 255, 0.7)", // Light Blue
    "rgba(40, 167, 69, 0.7)", // Dark Green
    "rgba(255, 87, 34, 0.7)", // Deep Orange
    "rgba(121, 85, 72, 0.7)", // Brown
    "rgba(233, 30, 99, 0.7)", // Pink
];
